import React from "react";
import { FaArrowLeft } from "react-icons/fa";
import { CreatorBadge } from "./CreatorBadge";
import { OrderSummary } from "./OrderSummary";
import { TipButton } from "./TipButton";

/**
 * Left-column gradient sidebar: back link → creator → amount →
 * order summary → tip button.
 *
 * On <900px the full sidebar is hidden and replaced by a compact
 * sticky top bar (`.pay-sidebar--mobile-bar`) so the Pay button
 * is above the fold.
 *
 * The back link goes to `history.back()` when possible (the user
 * navigated here from somewhere else in the site) and to "/" as a
 * defensive fallback. Direct-land payers (cold URL) get "/" which
 * is the logged-out home.
 */
export function Sidebar({ link }) {
  const handleBack = () => {
    if (window.history.length > 1) {
      window.history.back();
    } else {
      window.location.href = "/";
    }
  };

  return (
    <>
      {/* Compact mobile bar — creator + amount on one row, shown
       * only on <900px via CSS. On mobile the full desktop sidebar
       * is hidden, so this bar is the only source of the back
       * button + creator identity in the accessibility tree —
       * keep it reachable (no aria-hidden). */}
      <aside className="pay-sidebar--mobile-bar">
        <button className="pay-back" onClick={handleBack} aria-label="Go back">
          <FaArrowLeft size={12} /> Back
        </button>
        <div className="pay-sidebar--mobile-bar__body">
          <div className="pay-sidebar--mobile-bar__creator">
            {link?.creator?.username
              ? `@${link.creator.username}`
              : link?.creator?.displayAddress}
          </div>
          <div className="pay-sidebar--mobile-bar__amount">
            {link?.amountDisplay}
          </div>
        </div>
      </aside>

      {/* Full desktop sidebar */}
      <aside className="pay-sidebar">
        <button className="pay-back" onClick={handleBack} aria-label="Go back">
          <FaArrowLeft size={12} /> Back
        </button>
        <CreatorBadge link={link} />
        <OrderSummary link={link} />
        <TipButton />
      </aside>
    </>
  );
}
